/**
 * xpHelpers — formatadores e helpers visuais pro sistema de gamificação.
 */

export function formatXp(xp) {
  if (!xp || xp <= 0) return '0';
  if (xp >= 1000000) return (xp / 1000000).toFixed(1) + 'M';
  if (xp >= 10000) return Math.round(xp / 1000) + 'k';
  if (xp >= 1000) return (xp / 1000).toFixed(1) + 'k';
  return String(xp);
}

export function getLevelGradient(level) {
  // Bronze (1-3): cobre
  if (level >= 1 && level <= 3) return 'linear-gradient(135deg, #CD7F32 0%, #B87333 100%)';
  // Prata (4-6)
  if (level >= 4 && level <= 6) return 'linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)';
  // Ouro (7-9)
  if (level >= 7 && level <= 9) return 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)';
  // Platina (10-11)
  if (level >= 10 && level <= 11) return 'linear-gradient(135deg, #E5E4E2 0%, #BBB5AC 100%)';
  // Diamante (12-14)
  if (level >= 12 && level <= 14) return 'linear-gradient(135deg, #B9F2FF 0%, #4FC3F7 100%)';
  // Mestre (15+)
  if (level >= 15) return 'linear-gradient(135deg, #FF1493 0%, #C71585 100%)';
  return 'linear-gradient(135deg, #999 0%, #666 100%)';
}

export function getStreakIcon(streak) {
  return 'fas fa-fire';
}

export function getStreakColor(streak) {
  if (!streak || streak <= 0) return '#9E9E9E';
  if (streak < 3) return '#FFA726';     // laranja claro
  if (streak < 7) return '#FF7043';     // laranja
  if (streak < 14) return '#FF5722';    // vermelho-laranja
  if (streak < 30) return '#E64A19';    // vermelho
  if (streak < 100) return '#D32F2F';   // vermelho intenso
  return '#9C27B0';                     // roxo (epico)
}

export function getMissionTypeLabel(type) {
  var labels = {
    lessons: 'lições',
    units: 'unidades',
    hours: 'horas',
    score: 'nota média',
    streak: 'dias consecutivos',
    custom: 'objetivo'
  };
  return labels[type] || 'objetivo';
}

export default {
  formatXp,
  getLevelGradient,
  getStreakIcon,
  getStreakColor,
  getMissionTypeLabel
};
